module.exports = __webpack_public_path__ + "static/img/pImg.e527ed3a.png";